module.exports = __webpack_public_path__ + "static/media/temperature.91d09df5.ico";